import { render, staticRenderFns } from "./Type4b.vue?vue&type=template&id=9654048e&"
import script from "./Type4b.vue?vue&type=script&lang=js&"
export * from "./Type4b.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports